import { useCallback, useEffect, useState } from 'react';
import {
  getAddEmailProgressRequest,
  getEndAllProgressRequest,
  getPaperCatProgressRequest,
  getPrintingProgressRequest,
} from '../services/apiClient';

const idleStatus = { type: 'idle', message: '' };

export default function usePrintingProgress(
  token,
  isEnabled,
  type = 'printing'
) {
  const [progress, setProgress] = useState([]);
  const [status, setStatus] = useState(idleStatus);

  const fetchProgress = useCallback(async () => {
    if (!token || !isEnabled) {
      setProgress([]);
      setStatus(idleStatus);
      return;
    }

    setStatus({
      type: 'loading',
      message: 'جاري تحميل بيانات التقدم...',
    });
    try {
      const requester =
        {
          printing: getPrintingProgressRequest,
          'add-email': getAddEmailProgressRequest,
          'paper-cat': getPaperCatProgressRequest,
          'end-all': getEndAllProgressRequest,
        }[type] || getPrintingProgressRequest;

      const data = await requester(token);
      setProgress(Array.isArray(data) ? data : []);
      setStatus({ type: 'success', message: '' });
    } catch (error) {
      setProgress([]);
      setStatus({
        type: 'error',
        message: error.message || 'تعذر تحميل بيانات التقدم.',
      });
    }
  }, [token, isEnabled, type]);

  useEffect(() => {
    fetchProgress();
  }, [fetchProgress]);

  return {
    progress,
    status,
    reload: fetchProgress,
  };
}

